import { registerFilter } from "./registry.ts";
import { KioskFilter } from "./kioskFilter.tsx";
import { LocationFilter } from "./locationFilter.tsx";
import { ProductFilter } from "./productFilter.tsx";
import { DateFilter } from "./dateFilter.tsx";
import { DateFilterSimple } from "./dateFilterSimple.tsx";
import { TextBoxParamFilter } from "./textBoxParamFilter.tsx";
import { ComboBoxFilter } from "./comboBoxFilter.tsx";
import { ReplenishFilter } from "./replenishFilter.tsx";
import { TicketStatusFilter } from "./ticketStatusFilter.tsx";
import { ShowCheckboxFilter } from "./showCheckboxFilter.tsx";
import { GroupByFilter } from "./groupByFilter.tsx";

registerFilter("FilterKiosk", { component: KioskFilter, parameterOnly: true });
registerFilter("FilterGroupBy", { component: GroupByFilter, parameterOnly: true, secondaryParams: ["sGroupValue"] });
registerFilter("FilterLocation", { component: LocationFilter, parameterOnly: true });
registerFilter("FilterProduct", { component: ProductFilter, parameterOnly: true });
registerFilter("FilterDate", { component: DateFilter, parameterOnly: true });
registerFilter("FilterDateSimple", { component: DateFilterSimple, parameterOnly: true });
registerFilter("FilterTextBoxLike", { component: TextBoxParamFilter });
registerFilter("FilterTextBox", { component: TextBoxParamFilter });
// Combo/CheckCombo render inline in the column header (matches WebAdmin2);
// drop parameterOnly so the inline FilterBar picks them up. They still render
// in the advanced bar when used as function parameters (section 1 path).
registerFilter("FilterComboBox", { component: ComboBoxFilter });
registerFilter("FilterCheckComboBox", { component: ComboBoxFilter });
registerFilter("ReplenishFilter", { component: ReplenishFilter, parameterOnly: true });
registerFilter("FilterTicketStatus", { component: TicketStatusFilter, parameterOnly: true });
registerFilter("FilterShowCheckBox", { component: ShowCheckboxFilter, parameterOnly: true });
registerFilter("FilterHideCheckbox", { component: ShowCheckboxFilter, parameterOnly: true });
registerFilter("FilterCheckBox", { component: ShowCheckboxFilter, parameterOnly: true });
